// src/shortcuts/index.ts
function isMac() {
  if (typeof navigator === "undefined") return false;
  return /mac|iphone|ipad|ipod/i.test(navigator.platform || navigator.userAgent);
}
function parseCombo(combo) {
  const parts = combo.toLowerCase().split("+").map((p) => p.trim());
  const parsed = { key: "", mod: false, ctrl: false, meta: false, shift: false, alt: false };
  for (const part of parts) {
    if (part === "mod") parsed.mod = true;
    else if (part === "ctrl" || part === "control") parsed.ctrl = true;
    else if (part === "meta" || part === "cmd" || part === "command") parsed.meta = true;
    else if (part === "shift") parsed.shift = true;
    else if (part === "alt" || part === "option") parsed.alt = true;
    else parsed.key = part;
  }
  return parsed;
}
function eventMatches(parsed, event) {
  const key = event.key.toLowerCase();
  if (key !== parsed.key && event.code.toLowerCase() !== parsed.key) return false;
  const modActive = isMac() ? event.metaKey : event.ctrlKey;
  if (parsed.mod && !modActive) return false;
  if (parsed.ctrl && !event.ctrlKey) return false;
  if (parsed.meta && !event.metaKey) return false;
  if (parsed.shift !== event.shiftKey) return false;
  if (parsed.alt !== event.altKey) return false;
  if (!parsed.mod && !parsed.ctrl && !parsed.meta && (event.ctrlKey || event.metaKey)) return false;
  return true;
}
function isFromTextInput(event) {
  const t = event.target;
  if (!t) return false;
  const tag = t.tagName;
  return tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT" || t.isContentEditable;
}
var ShortcutManager = class {
  shortcuts = /* @__PURE__ */ new Map();
  listener = null;
  register(spec) {
    const entry = { ...spec, parsed: parseCombo(spec.combo) };
    this.shortcuts.set(spec.combo, entry);
    return () => this.shortcuts.delete(spec.combo);
  }
  registerAll(specs) {
    const offs = specs.map((s) => this.register(s));
    return () => offs.forEach((off) => off());
  }
  list() {
    return [...this.shortcuts.values()];
  }
  handle(event) {
    for (const spec of this.shortcuts.values()) {
      if (!spec.allowInInput && isFromTextInput(event)) continue;
      if (eventMatches(spec.parsed, event)) {
        if (spec.preventDefault !== false) event.preventDefault();
        spec.handler(event);
        return;
      }
    }
  }
  /** Attach the keydown listener to `target` (default `window`). Returns detach. */
  attach(target = typeof window !== "undefined" ? window : void 0) {
    if (!target) return () => void 0;
    this.listener = (e) => this.handle(e);
    target.addEventListener("keydown", this.listener);
    return () => {
      if (this.listener) target.removeEventListener("keydown", this.listener);
      this.listener = null;
    };
  }
};

export { ShortcutManager, parseCombo };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map